"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_hooks_1 = require("@l2p/common-hooks");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var Lockr = __importStar(require("lockr"));
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var NEXT_EMAIL_VERIFY_REQUEST = 'NEXT_EMAIL_VERIFY_REQUEST';
var EmailVerify = function () {
    var _a, _b, _c, _d;
    var data = (0, swr_hooks_1.useUser)().data;
    var t = (0, next_intl_1.useTranslations)('emailVerification');
    var defaultNextVerifyRequest = typeof window !== 'undefined'
        ? Lockr.get(NEXT_EMAIL_VERIFY_REQUEST)
        : undefined;
    var _e = (0, react_1.useState)(defaultNextVerifyRequest || null), nextVerifyRequest = _e[0], setNextVerifyRequest = _e[1];
    var _f = (0, react_1.useState)(''), error = _f[0], setError = _f[1];
    var _g = (0, swr_hooks_1.useRequestVerifyEmail)({
        successAction: function () {
            var nextRequestAvailable = (0, date_fns_1.addMinutes)(new Date(), 1);
            setNextVerifyRequest(nextRequestAvailable);
            if (typeof window !== 'undefined')
                Lockr.set(NEXT_EMAIL_VERIFY_REQUEST, nextRequestAvailable);
        },
        errorAction: function (e) {
            setError(e);
        },
    }), isSubmitting = _g.isSubmitting, requestVerifyEmail = _g.requestVerifyEmail;
    var seconds = (0, common_hooks_1.useTimer)({ endDate: nextVerifyRequest }).time.seconds;
    (0, react_1.useEffect)(function () {
        if (Number(seconds) <= 0) {
            Lockr.set(NEXT_EMAIL_VERIFY_REQUEST, null);
            setNextVerifyRequest(null);
        }
    }, [seconds]);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "480px", height: "auto", padding: "24px", saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            nextVerifyRequest ? (react_1.default.createElement("div", null,
                react_1.default.createElement("img", { src: "/img/email/email-verify.png", alt: "email-verify" }),
                react_1.default.createElement("h1", null, t('vefiryEmail')),
                react_1.default.createElement("span", null, (0, react_html_parser_1.default)(t('weSentEmail'))),
                react_1.default.createElement("p", { className: styles_module_scss_1.default.email }, (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.getOne) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.contacts) === null || _d === void 0 ? void 0 : _d.email),
                react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                        __html: t('clickTheLink'),
                    } }),
                react_1.default.createElement("p", { dangerouslySetInnerHTML: {
                        __html: "".concat(t('didntReceiveEmail'), " <span>").concat(seconds, " ").concat(t('seconds'), "</span>"),
                    } }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement("img", { src: "/img/email/email-verify.png", alt: "email-verify" }),
                    react_1.default.createElement("h1", null, t('verifyToEnterTitle')),
                    react_1.default.createElement("p", null, t('verifyToEnterText'))),
                react_1.default.createElement(ui_components_1.FixedButton, { type: "button", color: "gradient", text: "upper", height: "42px", maxWidth: "320px", onClick: function () { return requestVerifyEmail(); }, loading: isSubmitting },
                    react_1.default.createElement("span", null, t('verifyBtn'))))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.error }, error))));
};
exports.default = EmailVerify;
